import { QBuildTableRFC } from "./QBuildTableRFC";
import { Globals } from "./Globals";

export class QDownloadAppendTableRFC extends QBuildTableRFC {
  constructor() {
    super();
  }
  DoTransactionComplete = function (response) {
    var wsMgr = Globals._wsMgr;
    var r = JSON.parse(response);
    var success = r["success"];
    if (success) {
      var filename = r["filename"];
      wsMgr.DownloadPub(filename);
    }
  };
}
